import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({ name: 'looseCurrency' })
export class LooseCurrencyPipe implements PipeTransform {
  private _currencyPipe = inject(CurrencyPipe);

  public transform(
    value: string | number | null,
    currencyCode?: string | null,
    display?: string | boolean,
    digitsInfo?: string,
  ): string | null {
    // Convert strings to numbers if possible
    if (typeof value === 'string' && !isNaN(Number(value) - parseFloat(value))) {
      value = Number(value);
    }

    // If value is a string this means the try to convert it to number failled.
    if (typeof value === 'string') {
      return value;
    }

    // Here there'are 2 options:
    // 1) value is a number
    // 2) value is null. In this case let Angular's CurrencyPipe handle it
    return this._currencyPipe.transform(value, currencyCode!, display, digitsInfo);
  }
}
